import React from 'react';

const PaymentFinal = () => {
  return (
    <div className="w-full flex flex-col justify-between items-center gap-5 p-5 px-20 bg-slate-100">
      <div className="w-full flex flex-col items-end p-5 bg-slate-300 rounded-lg shadow-sm shadow-slate-400">
        <h3 className="w-full text-right border-b border-gray-500 pb-4">
          انتخاب آدرس
        </h3>
        <div className="flex flex-col justify-between items-end gap-2 pt-4">
          <span>:نام گیرنده</span>
          <span>:تلفن</span>
          <span>:کد پستی</span>
          <span>:آدرس</span>

          <div>
            <span>سایر آدرس ها</span>
          </div>
        </div>
      </div>

      <div className="w-full flex flex-col items-end p-5 bg-slate-300 rounded-lg shadow-sm shadow-slate-400">
        <h3 className="w-full text-right border-b border-gray-500 pb-4">
          شیوه ارسال سفارش
        </h3>

        <div>
          <div>
            <span>پیک معمولی</span>
          </div>

          <div>
            <span>پیک ویژه</span>
          </div>
        </div>
      </div>

      <div className="w-full flex flex-col items-end p-5 bg-slate-300 rounded-lg shadow-sm shadow-slate-400">
        <div>
          <h3>نوع پرداخت</h3>

          <div></div>
        </div>
        <div>
          <h3>صدور فاکتور</h3>

          <div></div>
        </div>
      </div>

      <div className="w-full flex flex-col items-end p-5 bg-slate-300 rounded-lg shadow-sm shadow-slate-400"></div>
    </div>
  );
};

export default PaymentFinal;
